export default {
  financeAccount: {
    column: {
      accountCode: '科目编码',
      accountDesc: '科目描述',
      isAvailable: '状态',
      auto: '自动生成',
    },
    collapseTitle: {
      baseTitle: '基本信息',
    },
    message: {
      onlyOneSelectData: '请选择一条数据进行操作！',
      noSelected: '您还未选择任何数据！',
    },
  },
};
